<template>
  <login-layout>    
    <login-link :header="true">Logging In</login-link>

    <login-input
      name="User Name"
      type="text"
      placeholder="Enter your User Name"
      v-model="userName"
    ></login-input>

    <login-input
      name="Password"
      type="password"
      placeholder="Enter your Password"
      v-model="password"
      :eyeToggle="!!password"
    ></login-input>

    <cms-button theme="dark" @click="onLogin">Log In</cms-button>

    <login-link @click="goToForgotUsername">Forgot Username?</login-link>
    <login-link @click="goToForgotPassword">Forgot Password?</login-link>
    <login-link @click="goToCreateUser">Create User</login-link>
  </login-layout>
</template>

<script>
import loginInput from "../components/login-input";
import loginLayout from "../components/login-layout";
import loginLink from "../components/login-link";
import router from "../router";
import validator from "../mixins/validator";
import { LoginStatus } from "../utils/constants/navigationConstants";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "Home",
  mixins: [validator],
  components: {
    "login-input": loginInput,
    "login-layout": loginLayout,
    "login-link": loginLink    
  },
  data() {
    return {
      _userName: null,
      _password: null,
    };
  },
  async mounted(){
    await this.$store.dispatch('getMaintenanceInfo');
  },
  computed: {
    ...mapGetters(["isAuthorized", "notActivatedReason"]),
    userName: {
      get: vm => vm.$data._userName,
      set(value) {
        this.$data._userName = value;
      }
    },
    password: {
      get: vm => vm.$data._password,
      set(value) {
        this.$data._password = value;
      }
    }
  },
  methods: {
    ...mapActions(["login"]),
    ...mapMutations(["addError", "clearAllNoties"]),
    async onLogin() {
      this.clearAllNoties();
      
      if (this.validate()) {
        await this.login({
          userName: this.userName,
          password: this.password
        });
        if (this.notActivatedReason == LoginStatus.EmailNotConfirmed){
          this.addError("Your email address has not been validated. Please click the link in the email you received when your account was set up to verify your email address.");
        } else if (!this.isAuthorized){
          this.addError("The User Name or Password you entered is invalid. Please try again.");
        } else {
          router.push({ path: "/" });
        }
      }
    },
    goToForgotPassword() {
      router.push({ name: "ForgotPassword" });
    },
    goToForgotUsername() {
      router.push({ name: "ForgotUsername" });
    },
    goToCreateUser() {
      router.push({ name: "CreateUser" });
    }
  }
};
</script>
